import React from 'react';

import { BaseSvgIcon } from 'reactComponents/icons/_baseSvgIcon';

export default function IconEye({
    width,
    height,
    className,
    onClick,
    tooltip,
    ...svgProps
}) {
    return (
        <BaseSvgIcon
            width={width}
            height={height}
            tooltip={tooltip}
            className={className}
            onClick={onClick}
            viewBox="0 0 24 24"
            pathD="M12 9a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5 5 5 0 0 1 5-5 5 5 0 0 1 5 5 5 5 0 0 1-5 5m0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
            {...svgProps}
        />
    );
}
